import classNames from 'classnames';

interface ActivityTitleProps {
  title: string | undefined;
  isCursorDefault: boolean;
  onClick: ((e: React.MouseEvent) => void) | undefined;
}

export function ActivityTitle(props: ActivityTitleProps) {
  const { title, isCursorDefault, onClick } = props;
  if (!title) return null;
  return (
    <div
      data-cy="notif-activity-item"
      className={classNames('font-semibold break-all cursor-pointer text-cyan-900', {
        'text-neutral-800 !cursor-default': isCursorDefault,
      })}
      onClick={onClick}
    >
      {title}
    </div>
  );
}
